module.exports = __webpack_public_path__ + "static/media/Paloma Ave, Burlingame, CA1.8d1f7ffd.jpg";